import tableFilter from '@/components/sys/TableFilter'
import axiosHelper from '@/utils/axiosHelper'
import { Loading } from 'element-ui'

export default {
  // 显示滤设弹框
  showTableFliterSet: async function (that, tableName) {
    const table = that[tableName]
    table.showFilterSetDialog = true
    table.changeShowFilterSetDialog = !table.changeShowFilterSetDialog
    table.FilterSetLoading = true
    const rtnObj = await tableFilter.getFilterInfo(table.tableCode)
    if (rtnObj.error === '000000') {
      table.userFilterInfo = rtnObj.filterInfo
    } else {
      that.$message.error(rtnObj.msg)
    }
    table.FilterSetLoading = false
  },

  // 重置滤设信息
  resetTableFilterSet: async function (that, tableName) {
    const table = that[tableName]
    table.FilterSetLoading = true
    const rtnObj = await tableFilter.getFilterInfo(table.tableCode)
    if (rtnObj.error === '000000') {
      table.userFilterInfo = rtnObj.filterInfo
    } else {
      that.$message.error(rtnObj.msg)
    }
    table.FilterSetLoading = false
  },

  // 滤设添加行
  addOneFilter: function (filterInfo) {
    filterInfo.push({
      ColumnCode: '',
      FilterType: '',
      Type: '1',
      DataType: '',
      DateFormat: '',
      DefaultVal1Type: '0',
      DefaultVal1: '',
      DefaultVal2Type: '0',
      DefaultVal2: '',
      OutDisplay: '0'
    })
  },

  // 滤设删除行
  deleteOneFilter: function (filterInfo, index) {
    filterInfo.splice(index, 1)
  },

  // 页面主表格默认过滤设置弹框表格列名称选择方法
  filterColumnChange: function (scope, columns) {
    for (let i = 0; i < columns.length; i++) {
      if (columns[i].ColumnCode === scope.row.ColumnCode) {
        scope.row.DataType = columns[i].DataType
        if (scope.row.DataType === '0') {
          scope.row.FilterType = '10'
          scope.row.DateFormat = ''
        } else if (scope.row.DataType === '1') {
          scope.row.FilterType = '00'
          scope.row.DateFormat = ''
        } else if (scope.row.DataType === '2') {
          scope.row.FilterType = '00'
          scope.row.DateFormat = ''
        } else if (scope.row.DataType === '3') {
          scope.row.FilterType = '00'
          scope.row.DateFormat = ''
        } else if (scope.row.DataType === '4') {
          scope.row.FilterType = '00'
          scope.row.DateFormat = 'yyyy-MM-dd'
        } else if (scope.row.DataType === '5') {
          scope.row.FilterType = '00'
          scope.row.DateFormat = ''
        }
      }
    }
  },

  // 判断数组中是否有相同的值（对对象数组无效）
  checkArrayHaveSameValue (ary) {
    const newAry = ary.sort()
    for (let i = 0; i < newAry.length - 1; i++) {
      if (newAry[i] === newAry[i + 1]) {
        return true
      }
    }
    return false
  },

  // 保存用户滤设
  saveUserTableFilter: async function (that, tableName) {
    const table = that[tableName]
    const newAry = []
    for (let i = 0; i < table.userFilterInfo.length; i++) {
      if (!table.userFilterInfo[i].ColumnCode) {
        that.$message.warning('列名称不能为空！')
        return
      }
      if (!table.userFilterInfo[i].FilterType) {
        that.$message.warning('过滤类型不能为空！')
        return
      }
      newAry.push(table.userFilterInfo[i].ColumnCode + '------' + table.userFilterInfo[i].FilterType)
    }
    if (this.checkArrayHaveSameValue(newAry)) {
      that.$message.warning('列名称和过滤类型的组合不能重复！')
      return
    }

    const loadingInstance = Loading.service({ fullscreen: true })
    const rtnObj = await axiosHelper.handle('/WebSYSAction/TableFilter.SaveTableUserFilterSettings', {
      filtersInfo: table.userFilterInfo,
      tableCode: table.tableCode
    })
    if (rtnObj.error === '000000') {
      table.showFilterSetDialog = false
      table.changeShowFilterSetDialog = !table.changeShowFilterSetDialog
      that.$message.success('恭喜你，保存过滤设置成功！')
      const filterInfoObj = await tableFilter.getFilterInfo(table.tableCode)
      if (filterInfoObj.error === '000000') {
        table.userFilterInfo = filterInfoObj.filterInfo
        tableFilter.refreshTableFliter(that, tableName)
      } else {
        that.$message.error(filterInfoObj.msg)
      }
    } else {
      that.$message.error(rtnObj.msg)
    }
    loadingInstance.close()
  },

  // 把用户过滤设置恢复为默认
  returnDefaultTableFilter: async function (that, tableName) {
    that.$confirm('确定要恢复默认设置吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(async () => {
      const table = that[tableName]
      const loadingInstance = Loading.service({ fullscreen: true })
      const rtnObj = await axiosHelper.handle('/WebSYSAction/TableFilter.SaveTableUserFilterSettings', {
        filtersInfo: [],
        tableCode: table.tableCode
      })
      if (rtnObj.error === '000000') {
        table.showFilterSetDialog = false
        table.changeShowFilterSetDialog = !table.changeShowFilterSetDialog
        that.$message.success('恭喜你，保存过滤设置成功！')
        const filterInfoObj = await tableFilter.getFilterInfo(table.tableCode)
        if (filterInfoObj.error === '000000') {
          table.userFilterInfo = filterInfoObj.filterInfo
          tableFilter.refreshTableFliter(that, tableName)
        } else {
          that.$message.error(filterInfoObj.msg)
        }
      } else {
        that.$message.error(rtnObj.msg)
      }
      loadingInstance.close()
    }).catch(() => {
    })
  }
}
